module.exports = __webpack_public_path__ + "img/F9.aa80361d.png";